import { useImgPreview } from '../hooks/useImgPreview';
import { Img } from '../img/img.component';
import { useBrand } from './brandContext';
import { defaultBrand } from './defaultBrand';
import defaultBrandIcons from './defaultBrandIcons';
import isTruthy from '@whiz-cart/node-shared/helpers/isTruthy';
import { BrandIcons, BrandImages, EmailBrandingImages } from '@whiz-cart/node-shared/models/brand/brand';
import { get } from 'lodash';
import { type CSSProperties } from 'react';

export interface BrandImageProps extends Omit<
    React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
    'onError' | 'src'
> {
    imageKey:
        | `images.${keyof BrandImages}`
        | `icons.${keyof BrandIcons}`
        | `customerIds.${number}.image`
        | `customerIds.${number}.logoImage`
        | `cartUiTutorialSlides.${number}.image`
        | `customIcons.${string}`
        | `emails.images.${keyof EmailBrandingImages}`;
    src?: string | File | null;
    className?: string;
    style?: CSSProperties;
    size?: number | string;
}

export default function BrandImage({ imageKey, src, size = imageKey.startsWith('icons.') ? 48 : 192, ...props }: BrandImageProps) {
    const brand = useBrand();

    const objectUrl = useImgPreview(src instanceof File ? src : undefined);
    if (src instanceof File) {
        return <img src={objectUrl} {...props} width={size} height={size} />;
    }

    const urls = [src, get(brand, imageKey), get(defaultBrand, imageKey)].filter(isTruthy).map((url) => ({ brandImageUrl: url }));

    const Component = defaultBrandIcons[imageKey.split('.')[1] ?? ''];

    return (
        <Img src={urls} srcMode="strict" {...props} width={size} height={size} retries={0}>
            {Component && <Component size={size} />}
        </Img>
    );
}
